import React, {useState} from "react";
import ContactDetailForDealModule from "../GlobalContactDetailsForDeal";
import { setContactDetails } from "../../actions/contactAction";
import { connect } from "react-redux";

const ContactDetailsInitialState = {
    /* props data */
    contactId: null,
    id: null,
    from: '',
    title: () => {return 'Contact details'},
    dealInfo:null,
    callbackOnOpen: () => {},
    dealCallback: () => {},
    closeContactDetails: () => {},
    dealTransferCallback: () => {},
    // loggedOnUser: null
};
/* 
open={props.open}
closeContactDetails={props.onClose}
title={props.title}
dealInfo={props.dealInfo || null}
id={props.id}
callbackOnOpen={props.callbackOnOpen}
from={props.from}
dealCallback={props.dealCallback}
loggedOnUser={props.loggedOnUser}
*/
const GlobalContactDetailsModule = (props) => {
    const [states, setStates] = useState(ContactDetailsInitialState);
    const [isOpenContactDetailsModal, setIsOpenContactDetailsModal] = useState(false);

    window.handleGlobalContactDetailsForDealModal = info => {
        if (info.open) {
            setStates({
                ...states,
                contactId: info.id,
                id: info.id,
                from: info.from,
                title: info.title,
                dealInfo: info.dealInfo === undefined ? ContactDetailsInitialState.dealInfo : info.dealInfo,
                callbackOnOpen: typeof info.callbackOnOpen === 'undefined' ? ContactDetailsInitialState.callbackOnOpen : info.callbackOnOpen,
                dealCallback: typeof info.dealCallback === 'undefined' ? ContactDetailsInitialState.dealCallback : info.dealCallback,
                closeContactDetails: typeof info.closeContactDetails === 'undefined' ? ContactDetailsInitialState.closeContactDetails : info.closeContactDetails,
                dealTransferCallback: typeof info.dealTransferCallback === 'undefined' ? ContactDetailsInitialState.dealTransferCallback : info.dealTransferCallback,
            });
            setIsOpenContactDetailsModal(true);            
        } else {
            setIsOpenContactDetailsModal(false);
            setStates(ContactDetailsInitialState);
        }
    }

    const closeContactDetailsModal = () => {
        props.setContactDetails({});
        if(states.closeContactDetails !== undefined){
            states.closeContactDetails()
        }
        setIsOpenContactDetailsModal(false);
        setStates(ContactDetailsInitialState);
    }

    return (
        <React.Fragment>
            {isOpenContactDetailsModal &&
                <ContactDetailForDealModule
                    open={isOpenContactDetailsModal}
                    onClose={closeContactDetailsModal}
                    {...states}
                />
            }
        </React.Fragment>
    );
}
const mapStateToProps = (state) => {
    return {};
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      setContactDetails: (params) => dispatch(setContactDetails(params)),
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(GlobalContactDetailsModule);